import { OdataManager } from '@/api/odata/odata-manager';
import { PackageKS2Review } from '@/api/model/interfaces';

export default class PackageKS2ReviewOdata extends OdataManager<PackageKS2Review> {}
